import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import styled from 'styled-components';
import Image from 'shared/Image';
import { Slide } from 'components/EmrSMS/Slide';
import { downloadApp } from 'shared/DownloadApp';
import { BaseBox, FlexBox, PrimaryButton, TertiaryButton } from '@docon/docon-ui-library';
import { colors } from 'utilities/colorConfig';

const doconImage = '/images/docon.svg';
const doconUniversal = '/images/emrSMSUniversal.svg';
const shadow = '/images/shadow.svg';

const Root = styled(FlexBox)`
  max-width: 450px;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  margin: 0 auto;
  padding: 28px 0;
  flex-direction: column;
  justify-content: space-between;
`;

const Footer = styled(BaseBox)`
  position: sticky;
  bottom: 0;
  margin: 5%;
  margin-bottom: 0;
  background-color: ${colors.white};

  ${TertiaryButton} {
    margin: auto;
    color: ${colors.tertiaryColor};
  }
`;

export type IProps = RouteComponentProps;

function EmrSMSComponent({
  history,
  onContinueToWeb,
  ...props
}: any) {

  function handleContinueToWebClick() {
    if (onContinueToWeb) onContinueToWeb();
    else {
      history.push(`/${window.location.search}`);
    }
  }

  function handleBtnClick() {
    window.open(downloadApp({ hasReturn: true }));
  }

  return (
    <Root {...props}>
      <Image src={doconImage} alt='Docon' />
      <Slide
        title1='Access all your health records anytime, anywhere'
        title2='Book appointments, Video consultations, Share concerns, Chat with doctor, & more. Docon works better with our app.'
        image1={doconUniversal}
        image2={shadow}
      />

      <Footer>
        <PrimaryButton
          isBlock
          m='0'
          title='Download the app'
          onClick={handleBtnClick}
        />
        <TertiaryButton
          title='Continue to website'
          onClick={handleContinueToWebClick}
        />
      </Footer>
    </Root>
  );
}

export default styled(withRouter(EmrSMSComponent))``;